import { Injectable } from '@angular/core';
import {environment} from 'src/environments/environment';
import { Subject } from 'rxjs';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageInsitutionManagementService {

  webKessUploadResult = new Subject();

  constructor(private service: PHBHPApiService) { }

  getCountryList() {
    return this.service.getApi('SOPManage/GetSOPCountriesList', true);
  }

  GetStatesByCountryId(countryId) {
    return this.service.getApi('states/GetStatesByCountryId/' + countryId, true);
  }

  createInstitution(data) {
    return this.service.postApi('ManageInstitution/CreateInstitution',data, true);
    //return this.service.postApi('Institutions/CreateInstitution',data, true);
  }

  getInstitution() {
    return this.service.getApi('Institutions', true);
  }
  deleteInstitutionById(id) {
    return this.service.deleteApi('ManageInstitution/DeleteInstitutionById/' + id, true);
  }
  getInstitutionById(id) {
    return this.service.getApi('Institutions/GetInstitution/' + id, true);
  }
  getInstitutionsbyId(id, roleId) {
    if(roleId != 3){
      return this.service.getApi('institutions/GetInstitutionsByIds/' + id, true);
    } else {
      return this.service.getApi('institutions/GetInstitutionByGroupId/' + id, true);
    }
  }
  // updateInstitutionById(data, id) {
  //   return this.service.putApi('ManageInstitution/UpdateInstitution/' + id, data, true);
  //   //return this.service.putApi('Institutions/UpdateInstitution/' + id, data, true);
  // }
  updateInstitutionById(data, insId, userId, lang, roleId) {

    let putJson = {
      "institutionId": parseInt(insId),
      "userId": userId,
      "languageCode": lang,
      "webUrl": environment.siteUrl,
      "institution" : data,
      "roleId": roleId
    }
    return this.service.putApi('ManageInstitution/UpdateInstitution/', putJson, true);
    //return this.service.putApi('Institutions/UpdateInstitution/' + id, data, true);
  }
  GetAllGroups() {
    return this.service.getApi('Institutions/GetAllGroups', true);
  }
  deleteUser(userId) {
    return this.service.deleteApi("Users/"+userId, true);
  }
  GetGroupsByCountryId(id) {
    return this.service.getApi('Institutions/GetGroupsByCountryId/' + id, true);
  }
  AddInstitutionToGroup(data) {
    return this.service.putApi(`Institutions/AddInstitutionToGroup/${data.institutionID}/${data.groupID}`, undefined, true);
  }
  GetUsersInstitutions(data) {
    return this.service.getApi(`ManageInstitution/GetUsersInstitutions/${data.userId}/${data.roleName.roleId}`, true);
  }
  GetUsersInstitutionDetails(data) {
    return this.service.getApi(`ManageInstitution/GetUsersInstitutionDetails/${data.userId}/${data.roleName.roleId}`, true);
  }
  GetInstitutionDetails(id) {
    // tslint:disable-next-line:max-line-length
    return this.service.getApi(`ManageInstitution/GetInstituionDetails/` + id, true);
  }
  getCountriesKeyValuePair() {
    return this.service.getApi("countries/GetCountriesKeyValuePair", true);
  }
  getProductPackages() {
    return this.service.getApi("ProductPackages", true);
  }
  getUsersTrialInstitutions(data){
    return this.service.getApi(`ManageInstitution/GetUsersTrialInstitutions/${data.userId}/${data.roleName.roleId}`, true);
  }
  createTrialInstitution(data){
    return this.service.postApi('Institutions/CreateTrialInstitution',data, true);
  }
  updateTrialInstitution(data, id){
    return this.service.putApi(`Institutions/UpdateTrialInstitution/${id}`, data, true);
  }
  convertTrialInstitution(data) {
    return this.service.postApi('Institutions/ConvertTrialInstitution',data, true);
  }
  getGlobalSOPs(){
    return this.service.getApi(`SOPs/GetGlobalSOPs`, true);
  }
  GetAllGlobalSOPs(countryId){
    return this.service.getApi(`SOPs/GetAllGlobalSOPs/${countryId}`, true);
  }
  GetAllNationalSOPs(countryId){
    return this.service.getApi(`SOPs/GetAllNationalSOPs/${countryId}`, true);
  }
  getwebKessActivationStatus(insId) {
    return this.service.getApi('Institutions/GetwebKessActivationStatus/' + insId, true);
  }
  // updateAdditionalChanges(insId, userId, data) {
  //   return this.service.putApi('Institutions/UpdateAdditionalChanges/'+ insId + '/'+ userId, data,true)
  // }
  updateAdditionalChanges(insId, userId, data, lang) {
    let updateJson = {
        "institutionId": parseInt(insId),
        "userId": userId,
        "languageCode" : lang,
        "webUrl": environment.siteUrl,
        "additionalChanges": {"activateWebKess": data.activateWebKess,"activateObservation": data.activateObservation, "activateConsumption": data.activateConsumption}
      
    };
    return this.service.putApi('ManageInstitution/UpdateAdditionalChanges', updateJson,true)
  }
  webKessTestConnection(insId,data) {
    return this.service.putApi('CHCIntegration/webKessTestConnection/'+ insId , data, true)
  }

  updateGeneralConfigurationWithTestConnection(insId, data) {
    return this.service.postApi('CHCIntegration/UpdateGeneralConfigurationWithTestConnection/'+ insId ,data, true)
  }

  UpdateGeneralConfigurationSettings(insId, data) {
    return this.service.postApi('ConfigureGeneral/UpdateGeneralConfigurationSettings/'+ insId ,data, true)
  }


  getGeneralConfigurationByInstitutionId(insId) {
    return this.service.getApi('ObserveObservation/GetGeneralConfigurationByInstitutionId/'+ insId , true)
  }


  GetWebKessInstitutions(userId, roleId, countryId) {
    return this.service.getApi(`ManageInstitution/GetWebKessInstitutions/${userId}/${roleId}/${countryId}`, true)
  }

  denyReq(data) {
    return this.service.putApi(`ManageInstitution/DenyAdditionalChanges`, data,  true)
  }

  checkPendingIntegrations(institutionId) {
    return this.service.getApi(`CHCIntegration/CheckPendingIntegrations/${institutionId}`, true);
  }
}
  
